import Index from "../components/homepage/main-screen/index";

const HomePage = ({ setLoginPopUp }) => {
  return (
    <>
      <Index setLoginPopUp={setLoginPopUp} />
    </>
  );
};

export default HomePage;
